import { CalendarDays } from 'lucide-react';
import { apiPaths, type EventsResponse } from '../../../shared/api/contract.ts';
import { DEFAULT_CITY } from '../../../shared/cities/index.ts';
import { FRESHNESS_POLICIES } from '../../../shared/freshness/index.ts';
import { PageContainer } from '../../components/layout/PageContainer.tsx';
import { SectionCard } from '../../components/SectionCard.tsx';
import { useApi } from '../../hooks/useApi.ts';
import { formatDayTime } from '../../lib/format.ts';

export function AgendaPage() {
  const events = useApi<EventsResponse>(apiPaths.events(DEFAULT_CITY.slug), FRESHNESS_POLICIES.events.refreshMs);
  return (
    <PageContainer path="/agenda">
      <SectionCard
        title="Événements à venir"
        icon={<CalendarDays size={20} aria-hidden="true" />}
        kind="events"
        section={events.data?.events}
        loading={events.loading}
        fetchError={events.error}
      >
        {(list, now) => {
          const upcoming = list
            .filter((e) => Date.parse(e.endsAt ?? e.startsAt) >= now.getTime())
            .toSorted((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt));
          return upcoming.length === 0 ? (
            <p className="state-message">Aucun événement à venir pour l’instant.</p>
          ) : (
            <ul className="item-list">
              {upcoming.map((e) => (
                <li key={e.id}>
                  {e.url === undefined ? (
                    <strong>{e.title}</strong>
                  ) : (
                    <a href={e.url} rel="noopener noreferrer" target="_blank">
                      <strong>{e.title}</strong>
                    </a>
                  )}
                  <span className="item-list__meta">
                    <time dateTime={e.startsAt}>{formatDayTime(e.startsAt)}</time>
                    {e.venue !== undefined && ` · ${e.venue.name}`}
                  </span>
                </li>
              ))}
            </ul>
          );
        }}
      </SectionCard>
    </PageContainer>
  );
}
